import { render, staticRenderFns } from "./newProject2.vue?vue&type=template&id=2c434644&scoped=true"
import script from "./newProject2.vue?vue&type=script&lang=js"
export * from "./newProject2.vue?vue&type=script&lang=js"
import style0 from "./newProject2.vue?vue&type=style&index=0&id=2c434644&prod&scoped=true&lang=css"
import style1 from "./newProject2.vue?vue&type=style&index=1&id=2c434644&prod&lang=css"
import style2 from "./newProject2.vue?vue&type=style&index=2&id=2c434644&prod&scoped=true&lang=scss"
import style3 from "./newProject2.vue?vue&type=style&index=3&id=2c434644&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c434644",
  null
  
)

export default component.exports